<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت   گالری ویدئو</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp; گالری جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingCats" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.vG_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.vG_Id)" dark v-if="!item.vG_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.vG_Id)" dark v-else> فعال</v-btn>
                            </template>
                            
                            <template v-slot:[`item.vG_VideoImage`]="{ item }">
                                <v-btn target="_blank" :href="CoverUrl+`${item.vG_VideoImage}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.vG_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New IG From Dialog-->
            <v-dialog fullscreen persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت گالری جدید</span>
                              <span v-else>ویرایش   &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md4 lg4 xl4 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    <div style="padding-top:23px;padding-bottom:5px;font-weight:bolder;font-size:17px">تنظیمات اصلی</div>
                                                                      
                                    <v-autocomplete :loading="isLoadingCatItems" v-model="galleryCategory" item-text="gC_Titles" item-value="gC_Id" :items="GalleryCatsItems" no-data-text="دسته بندی موجود نیست" color="#2a2d45" outlined dense label="انتخاب دسته بندی" ></v-autocomplete>
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="GalleryTitle" label="عنوان " ></v-text-field>
									<v-text-field color="#2a2d45" outlined dense v-model="VideoName" label=" آیدی ویدئو آپارات"></v-text-field>
                                   
                                    <v-text-field color="#2a2d45" outlined dense v-model="GallerySortField" label="ترتیب نمایش"></v-text-field>
                                   
                                    <v-combobox
                                        dense
                                        multiple
                                        v-model="videoKeyWords"
                                        label="کلیدواژه های  ویدئو"
                                        outlined
                                        clearable
                                        color="#2a2d45"
                                        chips
                                        append-icon="fas fa-a"
                                        deletable-chips
                                        class="tag-input"
                                        :search-input.sync="videoKeyWordSearch"
                                        @keyup.tab="updateVideoKeyWords"
                                        @paste="updateVideoKeyWords"
                                        ></v-combobox>
                                    <quill-editor placeholder="محتوای صفحه" label="محتوای صفحه" :content="EditorContent"
                                    @change="({html})=>{EditorContent = html}">
                                    </quill-editor>
                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="GalleryStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                    <f-up :OldFile="Image" @RetunedFileName="Image = $event" Root="GALLERYCHILD" Folder="VIDEOCOVERIMAGE" BtnTitle="عکس اصلی"></f-up>
                                    

                                    <v-btn @click="registerGalleryChild" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                                <v-flex xs12 sm12 md8 lg8 xl8 style="padding:15px;padding-top:0px !important"><!--Seo Form-->
                                    <seo-form FileLoc="CONTENTSEO" :Seo="SeoData" @SeoData="TakeSeoData"></seo-form>
                                </v-flex>
                                
                            </v-layout>
                        </v-flex>
                        
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
import { VueEditor } from "vue2-editor";
const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
import imgeditor from '../../../components/media/editor.vue';
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    name:"videoGallery",
   components: {
            Loading,
            JsonExcel,
            VueEditor
        },
    data:()=> ({
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        VideoImageSelectionDialog:false,
        galleryCategory:"",
        searchcategory:"",
        isLoadingCats:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"دسته بندی ",value:"vG_CatTitle",sortable:true,align:"right"},
            {text:"عنوان ",value:"vG_Title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"vG_SortField",sortable:true,align:"right"},
            {text:"عکس",value:"vG_VideoImage",sortable:true,align:"right"},
            {text:"وضعیت",value:"vG_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        GalleryTitle:"",
        GallerySortField:"",
        GalleryStatus:"",
        originalItems:[],
        ALLOEWDIMGSIZE:{},
        LogoUrl:"",
        CoverUrl:"",
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "دسته بندی":"vG_CatTitle",
            "عنوان":"vG_Title",
            "ترتیب نمایش":"vG_SortField",
            "وضعیت":"vG_Status",
            "کاور":"vG_VideoImage",
            "ویدئو":"vG_VideoUrl",
        },
        BrndDescription:"",
        GalleryCatsItems:[],
        isLoadingCatItems:true,
        Image:"",
        GalleryChildImgUrl:"",
        videoKeyWordSearch:"",
        EditorContent:"",
        videoKeyWords:[],
        VideoImageData:require('../../../assets/logo.png'),
        selectedLogoSource:"",
        videoUploadUrl:"",
        VideoName:"",
        seo:{},
        SeoData:{title:"",
      url:"",
      keywords:"",
      image:"",
      description:"",
      othermeta:""}
    }),
    async created()
    {
        let vm = this;
        vm.LogoUrl = ApiUrl.VideoGalleryChild;
        vm.CoverUrl = ApiUrl.VideoGalleryCover;
        vm.videoUploadUrl = ApiUrl.uploadVideo;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadChilds();
        await this.loadGalleryCatCombo();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadChilds();
        this.loadGalleryCatCombo();
        }
    },
    methods:{
        TakeSeoData(d)
        {
            console.error(d);
            this.seo = d;
        },
        LoadSeoFormData()
        {
            let vm = this;

            return vm.$store.getters.getSeoForm;
           
        },
        async uploadEntityLogo()
        {
            let vm = this;
            await axios.post(ApiUrl.registerGalleryChild,{DataUrl:vm.VideoImageData,Loc : "VIDEOCOVERIMAGE"}).then((res)=>{
                if(res.data.status)
                {
                    MSGHNDL.OK(res.data.msg);
                    vm.Image = res.data.data;
                    vm.VideoImageSelectionDialog = false;
                }
                else
                {
                    MSGHNDL.ERR(res.data.msg);
                }
            }).catch((err)=>{console.error(err);});
        },
        catLogoSelectedEvt(e)
        {
            let vm = this;
            let file = e.target.files[0];
            if(FTYPES.PRDCATLOGOFILETYPES.indexOf(file.type) == -1)
            {
                MSGHNDL.ERRFILEFORMAT();
                e.preventDefault();
                return;
            }
            if(file.size > 2000000)
            {
                MSGHNDL.ERRFILESIZE("2 مگابایت ");
                e.preventDefault();
                return;
            }
            MSGHNDL.CHKIMAGESIZE(file,0,0,0,0,1);
            
            if (FileReader) {
                var fr = new FileReader();
                fr.onload = function () {
                    vm.selectedLogoSource = fr.result;
                    vm.VideoImageSelectionDialog = true;
                }
                fr.readAsDataURL(file);
            }
        },
        change({coordinates, canvas}) {
           this.VideoImageData = canvas.toDataURL();
        },
        updateVideoKeyWords() {
            this.$nextTick(() => {
                this.videoKeyWords.push(...this.videoKeyWordSearch.split(","));
                this.$nextTick(() => {
                this.videoKeyWordSearch = "";
                });
            });
        },
        PickVideoName(fname)
        {
           this.VideoName = fname;
        },
        ...mapActions([  
        'setSeoForm',
        'setGalleryVideoChild'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.$store.getters.getSeoForm;
           
        },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.vG_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteVGalleryChild,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.vG_Id = id;
            await axios.post(ApiUrl.ActiveVGalleryChild,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.vG_Id = id;
            await axios.post(ApiUrl.DisableVGalleryChild,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.galleryCategory = "";
            vm.GalleryTitle = "";
            vm.GallerySortField = "";
            vm.videoKeyWords = [];
            vm.GalleryStatus = true;
            vm.EditorContent = "";
            vm.VideoImageData ="";
            vm.Image = "";
            vm.SeoData = ({
            title:"",
            url:"",
            keywords:"",
            image:"",
            description:"",
            othermeta:""
            });
            vm.setGalleryVideoChild("");
            vm.VideoName = "";
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.galleryCategory = item.vG_CatId;
            vm.GalleryTitle = item.vG_Title;
            vm.GallerySortField = item.vG_SortField;
            if(item.vG_Keywords != "")
            {
                vm.videoKeyWords = item.vG_Keywords.split(',');
            }
            vm.GalleryStatus = item.vG_Status;
            vm.EditorContent = item.vG_Description;
            vm.VideoImageData =vm.CoverUrl+ item.vG_VideoImage;
            vm.Image = item.vG_VideoImage;
            vm.SeoData = (JSON.parse(item.vG_Seo));
            vm.setGalleryVideoChild(vm.LogoUrl+item.vG_VideoUrl);
            vm.VideoName = item.vG_VideoUrl;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadChilds()
        {
            let vm = this;
            vm.isLoadingCats = true;
            debugger;
            await axios.post(ApiUrl.LoadVGalleryChild+'/'+vm.LANG).then((res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async loadGalleryCatCombo()
        {
            let vm = this;
            vm.isLoadingCatItems = true;

            await axios.post(ApiUrl.LoadGalleryCatCombo+'/2/'+vm.LANG).then((res)=>{
                vm.isLoadingCatItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.GalleryCatsItems = data.data;
                    console.error(vm.GalleryCatsItems);
                    
                }
            }).catch((err)=>{
                vm.isLoadingCatItems = false;
                console.error(err);
            });
        },
        async registerGalleryChild()
        {
            let vm = this;
            let Model = {};
            Model.VG_CatId = vm.galleryCategory;
            Model.VG_Title = vm.GalleryTitle;
            Model.VG_SortField = parseInt(vm.GallerySortField);
            Model.VG_Status = vm.GalleryStatus;
            Model.VG_VideoUrl = vm.VideoName;
            Model.VG_VideoImage = vm.Image;
            Model.VG_Keywords = (vm.videoKeyWords.length > 0)?vm.videoKeyWords.join(','):"";
            Model.VG_Description = vm.EditorContent;
            Model.Lang = vm.LANG;
            let SeoData = vm.seo;
            Model.VG_Seo = JSON.stringify(SeoData);

            let url = ApiUrl.AddVGalleryChild;
            if(vm.inEditingItem)
            {
                Model.VG_Id = vm.EditSelectedItem.vG_Id;
                url = ApiUrl.updateVGalleryChild;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadChilds();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>